export default __webpack_public_path__ + "static/media/char_body_005.61d1d5ec.png";